export class AssetOpConfirm {
    index: number;
    assetOpId: number;
    invNo: string;
    assetName: string;
    roomCodeIni: string;
    locationCodeIni: string;
    roomCodeFin: string;
    locationCodeFin: string;
    assetTypeName: string;
    purchaseDate: Date;
    serialNumber: string;
    quantity: number;
    valueInv: number;
    employeeInternalCodeInitial: string;
    employeeInternalCodeFinal: string;
    employeeFirstNameInitial: string;
    employeeFirstNameFinal: string;
    employeeLastNameInitial: string;
    employeeLastNameFinal: string;
}